<sl-grid
  [sidePadding]="config.grid.padding ?? '0px'"
  [totalColumns]="config.grid.columns"
  [backgroundColor]="'var(--color-grey-200)'"
  >
  <sl-column [startColumn]="1" [endColumn]="config.columns['menuContent'].end">
    @if (showMenu) {
      <nav role="navigation" aria-label="Salto al contenido">
        <ul class="navbar-center" aria-label="Menu accesible Skip Links">
          @for (item of menuItems; track item) {
            <li>
              <a
                href="#"
                #menuLink
                (click)="scrollToElement(item.element); $event.preventDefault()"
                (keydown.enter)="scrollToElement(item.element)"
                >{{ item.label }}</a
                >
              </li>
            }
          </ul>
        </nav>
      }
    </sl-column>
  </sl-grid>
